export function RangeSelection (pEditor, pRange)
{
  this.getCurrent = (isUni) =>
  {
    try
    {
      return (BEditor.browser.isIE && !isUni) ? pEditor.iFrameDoc.selection : pEditor.iFrame.getSelection();
    }
    catch (err)
    {
      return null;
    }
  };


  this.clear = () =>
  {
    var currentSelection = this.getCurrent(true),
        currentRange = pRange.getCurrent(true);

    if (currentSelection && currentRange)
    {
      currentSelection.removeAllRanges();
      currentRange.collapse(true);
      currentSelection.addRange(currentRange);
    }
  };
  
  
  this.selectControlRangeElement = (element) =>
  {
    var currentRange;

    if (pEditor.iFrameDoc.body.createControlRange)
    {
      currentRange = pEditor.iFrameDoc.body.createControlRange();
      currentRange.add(element);
      currentRange.select();
      pRange.save(true);
    }
  };
}